import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import { MatDialog } from '@angular/material/dialog';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { DatePipe } from '@angular/common';
import { RMDashboardService } from '../../services/rm-dashboard.service';
import Drilldown from 'highcharts/modules/drilldown';
import More from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AGGridUTCTOLocalDateService } from 'src/app/services/aggrid-utc-to-local-date.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { TechnicianService } from '../../services/technician.service';
import { WOSubtasksDialogComponent } from '../technician-execution/wo-subtasks-dialog.component';

More(Highcharts);
Drilldown(Highcharts);
Exporting(Highcharts);
@Component({
  selector: 'app-rm-dashboard',
  templateUrl: './rm-dashboard.component.html',
  styleUrls: ['./rm-dashboard.component.scss'],
})
export class RmDashboardComponent implements OnInit {
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('breakDownDialog') private breakDownDialog!: TemplateRef<any>;
  @ViewChild('allSelectedWO') private allSelectedWO: any;
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredComponents: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList!: any[];
  LineList!: any[];
  unitList!: any[];
  componentList!: any;
  permisson!: any;
  CLLDashboardForm!: FormGroup;
  TotalDefects!: any;
  TotalDefecteSolved!: any;
  CILAdherence!: any;
  TotalDefectsPerc!: any;
  CILTask!: any;
  key: any;
  dashboardData!: any;
  chartCILTask!: Chart;
  chartCILType!: Chart;
  chartCILTool!: Chart;
  highCharts: any;
  image!: any;
  currentImagePath!: any;
  defaultExcelExportParams: any;
  frameworkComponents: any;
  rowData!: any[];
  allRowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  languageDir = 'ltr';
  langObj: any = {};
  /** i18n section shared by the PM pages. */
  private readonly PAGE = 'PM';
  moduleId!: any;
  pageId!: any;
  blobStorageUrl: string = '';
  gridOptions: any = {
    defaultColDef: {
      rowStyle: {
        'border-bottom': 'white 10px solid',
        'border-top': 'white 10px solid',
        'max-height': '50px',
      },
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    popupParent: document.querySelector('body'),
  };
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  unitPickerIsOpen: boolean = false;
  isPickFromUnit: boolean = false;
  HeaderData: any = {
    Group: '',
    StartDate: new Date(
      moment().subtract(1, 'd').set('hour', 6).set('minutes', 0).toString()
    ),
    EndDate: new Date(),
    Plant: '',
    Line: '',
    WOType: '',
  };
  HeaderForm: any;
  TotalWO: any = 0;
  ClosedWO: any = 0;
  CompletedWO: any = 0;
  OpenedWO: any = 0;
  TotalWOCompiled: any = 0;
  ClosedWOCompiled: any = 0;
  CompletedWOCompiled: any = 0;
  OpenedWOCompiled: any = 0;
  MTTRDays: any = 0;
  MTTRHours: any = 0;
  MTTRMinutes: any = 0;
  MTBFDays: any = 0;
  MTBFHours: any = 0;
  MTBFMinutes: any = 0;
  UsedSpareParts: any = 0;
  TotalMaintenanceScrap: any = 0;
  TreeData: any = [];
  Minorval: any = 0;
  Moderateval: any = 0;
  Majorval: any = 0;
  Minor: any = 0;
  Moderate: any = 0;
  Major: any = 0;
  ResponseTime: any = 0;
  TroubleShootTime: any = 0;
  WaitingSPTime: any = 0;
  MDTTime: any = 0;
  UnitsInGroup: any = [];
  PlantsInGroup: any = [];
  UnitsByLine: any = [];
  ComponentByUnit: any = [];
  chartMachine!: Chart;
  chartComponent!: Chart;
  isGreenMark!: boolean;
  selectedDate = 'Today';
  filteredDate: any[];
  drilldownData: any;
  spinnerText: string = '';
  userList: any = [];
  ChartName: any;
  isGreenOpenMark!: boolean;
  isGreenCompleteMark!: boolean;
  isGreenCloseMark!: boolean;
  openedPercentage: any;
  completedPercentage: any;
  closedPercentage: any;
  minorArr: any = [];
  moderateArr: any = [];
  majorArr: any = [];
  chartMinor!: Chart;
  chartModerate!: Chart;
  chartMajor!: Chart;
  isMinorChart: boolean = false;
  isModerateChart: boolean = false;
  isMajorChart: boolean = false;
  selected: any;
  lang: any;
  isAccess = ApplicationPermission.RM_DASHBOARD_ACCESS;
  isWrite = ApplicationPermission.RM_DASHBOARD_CREATE;
  isUpdate = ApplicationPermission.RM_DASHBOARD_UPDATE;
  isDelete = ApplicationPermission.RM_DASHBOARD_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  WOTypeList!: any[];
  filteredWOTypes: any;

  constructor(
    public translater: TranslaterService,
    public translate: TranslateService,
    private toaster: ToastrService,
    public router: Router,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private baseApi: BaseApi,
    private pmDashboardService: RMDashboardService,
    private fb: FormBuilder,
    public agGridUTCTOLocalDate: AGGridUTCTOLocalDateService,
    private rmconfigurationService: RMconfigurationService,
    private employeeService: EmployeeService,
    public managerExecutionService: ManagerExecutionService,
    private technicianService: TechnicianService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      // Repaint from the JSON files at once; getLangWords() repaints again
      // when the database tags arrive. Without this the page only changed
      // language after a reload.
      this.langObj = null;
      this.applyLanguageToView();
      this.getLangWords();
    });

    this.filteredDate = [
      { value: 'Today' },
      { value: 'Yesterday' },
      { value: 'Last Week' },
      { value: 'Last Month' },
    ];

    this.frameworkComponents = {
      buttonRenderer: ButtonViewRendererComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Subtasks',
        field: 'subtasks',
        maxWidth: 120,
        cellRenderer: (params: any) => {
          return '<button class="btn" style="color: white; background: #17a2b8; padding: 7px 10px; border: none; border-radius: 5px; cursor: pointer;" title="View"><i class="fa fa-eye" aria-hidden="true" style="color: white; padding-bottom: 15px"></i></button>';
        },
        onCellClicked: (params: any) => {
          this.openSubtaskDialog(params.data);
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line',
        field: 'line.plDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Line/Machine',
        field: 'units.puDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Assembly',
        field: 'assembly.assblyDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'SubAssembly',
        field: 'subAssembly.sAsblyDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Component',
        field: 'component.componentName',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'WO Id',
        field: 'WOId',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Description',
        field: 'Remark',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Type',
        field: 'WOType.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Failure Mode',
        field: 'FailureMode.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Status',
        field: 'WOStatus',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician',
        field: 'managerExc.assignUser',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Priority',
        field: 'managerExc.Priority.Name',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts',
        field: 'SpareParts',
        valueFormatter: (params) =>
          params.value ? 'Required' : 'Not Required',
        headerValueGetter: this.localizeHeader.bind(this),
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Spare Part Code',
        field: 'managerExc.SparePartCode',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Machine Breakdown',
        field: 'MachineBreakdown',
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created At',
        field: 'CreatedAt',
        type: 'date',
        filter: 'agSetColumnFilter',
        valueFormatter: function (params: any) {
          return params.value !== null
            ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Raise Time',
        field: 'TimeStamp',
        type: 'date',
        filter: 'agSetColumnFilter',
        valueFormatter: function (params: any) {
          return params.value !== null
            ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Manager Assign Time',
        field: 'managerExc.CreatedAt',
        type: 'date',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html != '' ? moment(html).format('DD/MM/YYYY HH:mm:ss a') : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician Start Time',
        field: 'techExc.StartTime',
        type: 'date',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html != '' ? moment(html).format('DD/MM/YYYY HH:mm:ss a') : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SP Request Time',
        field: 'techExc.SPRequestTime',
        type: 'date',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html != '' ? moment(html).format('DD/MM/YYYY HH:mm:ss a') : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SP Received Time',
        field: 'techExc.SPReceivedTime',
        type: 'date',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html != '' ? moment(html).format('DD/MM/YYYY HH:mm:ss a') : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician Complete Time',
        field: 'techExc.CompleteTime',
        type: 'date',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html != '' ? moment(html).format('DD/MM/YYYY HH:mm:ss a') : '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Closed At',
        field: 'ClosedAt',
        filter: 'agSetColumnFilter',
        type: 'date',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Operator Picture',
        field: 'UploadPicture',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = '';
          if (params.value) {
            html = `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value
              }" src="${Constants.BLOB_STORAGE_URL + params.value}">`;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Manager Remark',
        field: 'managerExc.ManagerRemarks',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician Picture',
        field: 'techExc.AfterPicture',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params.value) {
            html = `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value
              }" src="${Constants.BLOB_STORAGE_URL + params.value}">`;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Technician Remark',
        field: 'techExc.Remarks',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Total Repair time',
        field: 'techExc.RepairTime',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + 'min' : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
       {
        headerName: 'Repair Time',
        field: 'techExc.MainTaskRepairTime',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + 'min' : '';
          return html;
        },
       headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Response Time',
        field: 'ResponseTime',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + 'min' : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'TroubleShoot Time',
        field: 'TroubleShootTime',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + 'min' : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Waiting SP Time',
        field: 'WaitingSPTime',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + 'min' : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
       {
        headerName: 'Maintenance Scrap',
        field: 'MaintenanceScrap',
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value + ' ' + '' : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];

    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getLangWords();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.HeaderForm = this.fb.group({
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required],
      Line: ['', Validators.required],
      WOType: ['', Validators.required],
    });
    this.initform();
    this.getLine();
    this.getUserList();
    this.getWOType();
  }

  initform() {
    this.HeaderData.ChartUnit = 0;
  }

  getUserList() {
    this.spinnerText = this.t('SpinnerFetchingUserData', 'Fetching User Data');
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.userList = res;
        this.spinner.hide();
        this.onChangeDate();
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  getLine() {
    const key = {
      PlantCode: this.plantSession?.plantCode,
      userCode: this.userSession?.userCode,
    };
    this.spinner.show();
    this.rmconfigurationService.getLineData(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.LineList = data.lstLine;
        this.filteredLines = this.LineList.slice();
        this.HeaderForm.get('Line')?.setValue(-1);
      },
      (error: any) => {
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  getWOType() {
    this.spinnerText = this.t('SpinnerFetchingWOTypeData', 'Fetching WO Type Data');
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'RM',
    };
    this.rmconfigurationService.getWOType(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.WOTypeList = res.woTypeList;
        this.filteredWOTypes = this.WOTypeList.slice();
        // this.HeaderForm.get('WOType')?.setValue(-1);
        const allWO = this.filteredWOTypes.map((x) => x.ID);
        this.HeaderForm.controls.WOType.patchValue(['-1', ...allWO]);
        this.getRMDashboard();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  onChangeDate() {
    if (this.HeaderData.Date == 'Today') this.today();
    else if (this.HeaderData.Date == 'Yesterday') this.yesterday();
    else if (this.HeaderData.Date == 'Last Week') this.lastWeek();
    else if (this.HeaderData.Date == 'Last Month') this.lastMonth();
  }

  openSubtaskDialog(rowdata: any): void {
    const data: any = {
      isAssignedToMainTask: rowdata?.IsAssignedToMainTask,
      responsibleId: this.userSession?.userCode,
    };

    if (rowdata.WOId > 0) {
      data.technicianExecutionWOID = rowdata?.techExc?.ID;
      data.WOId = rowdata?.WOId;
    } else {
      data.technicianTaskId = rowdata?.ID;
    }

    this.technicianService.GetSubTaskWorkOrdersByTaskOrWOID(data).subscribe(
      (subtaskData: any) => {
        const dialogRef = this.dialog.open(WOSubtasksDialogComponent, {
          width: '1500px',
          height: 'auto',
          data: {
            rowData: subtaskData,
            technicianExecutionWOID: data.technicianExecutionWOID,
            WOId: data.WOId,
            technicianList: this.userList || [],
            vendorsList: [],
            hideActionColumn: true,
            viewOnlyMode: true,
          },
        });

        dialogRef.afterClosed().subscribe((result) => {

        });
      },
      (error) => {
        console.error('Error fetching subtask data:', error);
      }
    );
  }

  openModal() {
    this.unitPickerIsOpen = true;
    this.isPickFromUnit = true;
  }

  // setUnit(event: any) {
  //   this.unitPickerIsOpen = false;
  //   this.HeaderData.ChartUnit = 0;
  //   this.HeaderData.Line = 0;
  //   this.HeaderData.Unit = 0;
  //   this.HeaderData.Assembly = 0;
  //   this.HeaderData.SubAssembly = 0;
  //   this.HeaderData.Component = 0;
  //   this.HeaderData.displayMachine = '';
  //   if (event.Plant && event.line)
  //     this.HeaderData.displayMachine = `${event.plantName}/${event.divisionName}/${event.departmentName}/${event.lineName}`;
  //   else this.HeaderData.displayMachine = '';
  //   if (event.Level == 'Line') {
  //     this.HeaderData.Line = event.line;
  //   } else if (event.Level == 'Unit') {
  //     this.HeaderData.Line = event.line;
  //     this.HeaderData.Unit = event.units;
  //   } else if (event.Level == 'Assembly') {
  //     this.HeaderData.Line = event.line;
  //     this.HeaderData.Unit = event.units;
  //     this.HeaderData.Assembly = event.assembly;
  //   } else if (event.Level == 'SubAssembly') {
  //     this.HeaderData.Line = event.line;
  //     this.HeaderData.Unit = event.units;
  //     this.HeaderData.Assembly = event.assembly;
  //     this.HeaderData.SubAssembly = event.subAssembly;
  //   } else if (event.Level == 'Component') {
  //     this.HeaderData.Line = event.line;
  //     this.HeaderData.Unit = event.units;
  //     this.HeaderData.Assembly = event.assembly;
  //     this.HeaderData.SubAssembly = event.subAssembly;
  //     this.HeaderData.Component = event.component;
  //   }
  //   setTimeout(() => {
  //     this.getRMDashboard();
  //   }, 500);
  // }

  /**
   * Resolve a label:  langObj (database)  ->  "PM.<key>"  ->  flat "<key>"
   * ->  the English fallback passed by the caller. All PM pages share the
   * "PM" i18n section.
   */
  public t(key: string, fallback: string): string {
    if (this.langObj && this.langObj[key]) {
      return this.langObj[key];
    }
    return this.lookup(this.PAGE + '.' + key) || this.lookup(key) || fallback;
  }

  private lookup(key: string): string | null {
    const value = this.translate.instant(key);
    if (typeof value === 'string' && value !== key) {
      return value;
    }
    if (value && typeof value === 'object' && typeof value.title === 'string') {
      return value.title;
    }
    return null;
  }

  public localizeHeader(parameters: any) {
    const colDef = parameters && parameters.colDef ? parameters.colDef : {};
    return this.getTransalatedValue(colDef.field, colDef.headerName);
  }

  /**
   * Header lookup: database first (keyed on the field name, as before), then
   * the JSON files (keyed on the readable header and its space-free form),
   * then the English header -- never the raw field name.
   */
  getTransalatedValue(value: string, headerLabel?: string): string {
    const compact = headerLabel ? headerLabel.replace(/\s+/g, '') : '';
    for (const candidate of [value, headerLabel, compact]) {
      if (candidate && this.langObj && this.langObj[candidate]) {
        return this.langObj[candidate];
      }
    }
    for (const candidate of [compact, headerLabel, value]) {
      if (!candidate) {
        continue;
      }
      const hit = this.lookup(this.PAGE + '.' + candidate) || this.lookup(candidate);
      if (hit) {
        return hit;
      }
    }
    return headerLabel ? headerLabel : value;
  }

  /** Repaint the grid without waiting for the database tag request. */
  private applyLanguageToView(): void {
    try {
      this.gridApi?.refreshHeader();
      this.gridApi?.refreshCells({ force: true });
    } catch (e) {
      // a destroyed grid must not break the language switch
    }
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.applyLanguageToView();
    }, () => {
      // the JSON files already carry the new language, keep the repaint
      this.applyLanguageToView();
    });
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  // udpateNodeParentDetails() {
  //   if (this.TreeData && this.TreeData.length) {
  //     this.TreeData.forEach((group: any) => {
  //       if (group.children && group.children.length) {
  //         group.children.forEach((plant: any) => {
  //           plant.groupName = group.text;
  //           plant.groupId = group.PrimaryId;
  //           if (plant.children && plant.children.length) {
  //             plant.children.forEach((division: any) => {
  //               division.plantId = plant.PrimaryId;
  //               division.plantName = plant.text;
  //               division.groupName = group.text;
  //               division.groupId = group.PrimaryId;
  //               if (division.children && division.children.length) {
  //                 division.children.forEach((department: any) => {
  //                   department.divisionId = division.PrimaryId;
  //                   department.divisionName = division.text;
  //                   department.plantId = plant.PrimaryId;
  //                   department.plantName = plant.text;
  //                   department.groupId = group.PrimaryId;
  //                   department.groupName = group.text;
  //                   if (department.children && department.children.length) {
  //                     department.children.forEach((line: any) => {
  //                       line.departmentId = department.PrimaryId;
  //                       line.departmentName = department.text;
  //                       line.divisionId = division.PrimaryId;
  //                       line.divisionName = division.text;
  //                       line.plantId = plant.PrimaryId;
  //                       line.plantName = plant.text;
  //                       line.groupId = group.PrimaryId;
  //                       line.groupName = group.text;
  //                       if (line.children && line.children.length) {
  //                         line.children.forEach((unit: any) => {
  //                           unit.lineId = line.PrimaryId;
  //                           unit.lineName = line.text;
  //                           unit.departmentId = department.PrimaryId;
  //                           unit.departmentName = department.text;
  //                           unit.divisionId = division.PrimaryId;
  //                           unit.divisionName = division.text;
  //                           unit.plantId = plant.PrimaryId;
  //                           unit.plantName = plant.text;
  //                           unit.groupId = group.PrimaryId;
  //                           unit.groupName = group.text;
  //                           if (unit.children && unit.children.length) {
  //                             unit.children.forEach((assembly: any) => {
  //                               assembly.unitName = unit.text;
  //                               assembly.unitId = unit.PrimaryId;
  //                               assembly.lineId = line.PrimaryId;
  //                               assembly.lineName = line.text;
  //                               assembly.departmentId = department.PrimaryId;
  //                               assembly.departmentName = department.text;
  //                               assembly.divisionId = division.PrimaryId;
  //                               assembly.divisionName = division.text;
  //                               assembly.plantId = plant.PrimaryId;
  //                               assembly.plantName = plant.text;
  //                               assembly.groupId = group.PrimaryId;
  //                               assembly.groupName = group.text;
  //                               if (
  //                                 assembly.children &&
  //                                 assembly.children.length
  //                               ) {
  //                                 assembly.children.forEach(
  //                                   (subAssembly: any) => {
  //                                     subAssembly.assemblyName = assembly.text;
  //                                     subAssembly.assemblyId =
  //                                       assembly.PrimaryId;
  //                                     subAssembly.unitName = unit.text;
  //                                     subAssembly.unitId = unit.PrimaryId;
  //                                     subAssembly.lineId = line.PrimaryId;
  //                                     subAssembly.lineName = line.text;
  //                                     subAssembly.departmentId =
  //                                       department.PrimaryId;
  //                                     subAssembly.departmentName =
  //                                       department.text;
  //                                     subAssembly.divisionId =
  //                                       division.PrimaryId;
  //                                     subAssembly.divisionName = division.text;
  //                                     subAssembly.plantId = plant.PrimaryId;
  //                                     subAssembly.plantName = plant.text;
  //                                     subAssembly.groupId = group.PrimaryId;
  //                                     subAssembly.groupName = group.text;
  //                                     if (
  //                                       subAssembly.children &&
  //                                       subAssembly.children.length
  //                                     ) {
  //                                       subAssembly.children.forEach(
  //                                         (component: any) => {
  //                                           component.subAssemblyName =
  //                                             subAssembly.text;
  //                                           component.subAssemblyId =
  //                                             subAssembly.PrimaryId;
  //                                           component.assemblyName =
  //                                             assembly.text;
  //                                           component.assemblyId =
  //                                             assembly.PrimaryId;
  //                                           component.unitName = unit.text;
  //                                           component.unitId = unit.PrimaryId;
  //                                           component.lineId = line.PrimaryId;
  //                                           component.lineName = line.text;
  //                                           component.departmentId =
  //                                             department.PrimaryId;
  //                                           component.departmentName =
  //                                             department.text;
  //                                           component.divisionId =
  //                                             division.PrimaryId;
  //                                           component.divisionName =
  //                                             division.text;
  //                                           component.plantId = plant.PrimaryId;
  //                                           component.plantName = plant.text;
  //                                           component.groupId = group.PrimaryId;
  //                                           component.groupName = group.text;
  //                                         }
  //                                       );
  //                                     }
  //                                   }
  //                                 );
  //                               }
  //                             });
  //                           }
  //                         });
  //                       }
  //                     });
  //                   }
  //                 });
  //               }
  //             });
  //           }
  //         });
  //       }
  //     });
  //   }
  // }

  today(): void {
    this.HeaderData.ChartUnit = 0;
    this.makeDatatoDay();
    this.getRMDashboard();
  }

  yesterday(): void {
    this.HeaderData.ChartUnit = 0;
    this.makeDataYesterDay();
    this.getRMDashboard();
  }

  lastWeek(): void {
    this.HeaderData.ChartUnit = 0;
    this.makeDataLastWeek();
    this.getRMDashboard();
  }

  lastMonth(): void {
    this.HeaderData.ChartUnit = 0;
    this.makeDataLastMonth();
    this.getRMDashboard();
  }

  getRMDashboard() {
    if (this.isAccess) {
      if (
        !this.HeaderData.Line ||
        !this.HeaderData.WOType ||
        !this.HeaderData.StartDate ||
        !this.HeaderData.EndDate
      ) {
        return;
      } else {
        const woType = this.HeaderData.WOType;
        const result = woType.includes('-1')
          ? woType.filter((type) => type !== '-1').join(',')
          : woType.join(',');

        const HeaderData: any = {
          Group: this.groupSession.groupCode,
          PlantId: this.plantSession?.plantCode,
          StartDate: this.HeaderData.StartDate
            ? this.HeaderData.StartDate
            : moment()
              .subtract(1, 'd')
              .set('hour', 6)
              .set('minutes', 0)
              .toString(),
          EndDate: this.HeaderData.EndDate
            ? this.HeaderData.EndDate
            : new Date(),
          Line: this.HeaderData.Line,
          Unit: this.HeaderData.ChartUnit,
          WOType: result,
        };
        this.spinner.show();
        this.pmDashboardService.getRMDashboardData(HeaderData).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.dashboardData = res;
            let dummydata = {
              point: {
                options: {
                  drilldown: '-1',
                },
              },
            };
            this.getTableData(dummydata, this.HeaderData.Line);
            this.setData();
            this.spinner.hide();
          },
          (error: any) => {
            this.toaster.error('error', error.message);
            this.spinner.hide();
          }
        );
      }
    }
  }

  setData() {
    if (this.dashboardData !== null) {
      this.TotalWO = this.dashboardData.TotalWOCount;
      this.ClosedWO = this.dashboardData.ClosedWOCount;
      this.CompletedWO = this.dashboardData.CompletedWOCount;
      this.OpenedWO = this.dashboardData.OpenedWOCount;
      this.UsedSpareParts = this.dashboardData.UsedSparePartsCount;
      this.MTTRDays = 0;
      this.MTTRHours = 0;
      this.MTTRMinutes = 0;
      this.MTBFDays = 0;
      this.MTBFHours = 0;
      this.MTBFMinutes = 0;
      this.Minor = 0;
      this.Moderate = 0;
      this.Major = 0;
      this.TotalMaintenanceScrap = 0;
      this.minorArr = [];
      this.moderateArr = [];
      this.majorArr = [];
      if (this.TotalWO) {
        let averageTotal = this.dashboardData.AverageWOTotal;
        this.isGreenOpenMark = this.OpenedWO <= averageTotal ? true : false;
        this.isGreenCompleteMark =
          this.CompletedWO >= averageTotal ? true : false;
        this.isGreenCloseMark = this.ClosedWO >= averageTotal ? true : false;
        this.openedPercentage = this.dashboardData.openedPercentage;
        this.completedPercentage = this.dashboardData.completedPercentage;
        this.closedPercentage = this.dashboardData.closedPercentage;
      } else {
        this.isGreenOpenMark = true;
        this.isGreenCompleteMark = true;
        this.isGreenCloseMark = true;
      }

      this.Minor = this.dashboardData.Minorval;
      this.Moderate = this.dashboardData.Moderateval;
      this.Major = this.dashboardData.Majorval;

      this.MTBFDays = this.dashboardData.MTBFDays;
      this.MTBFHours = this.dashboardData.MTBFHours;
      this.MTBFMinutes = this.dashboardData.MTBFMinutes;

      this.ResponseTime = this.dashboardData.ResponseTime;
      this.TroubleShootTime = this.dashboardData.TroubleShootTime;
      this.WaitingSPTime = this.dashboardData.WaitingSPTime;
      this.MDTTime = this.dashboardData.MDTTime;

      this.MTTRDays = this.dashboardData.MTTRDays;
      this.MTTRHours = this.dashboardData.MTTRHours;
      this.MTTRMinutes = this.dashboardData.MTTRMinutes;

      this.minorArr = this.dashboardData.minorArr;
      this.moderateArr = this.dashboardData.moderateArr;
      this.majorArr = this.dashboardData.majorArr;
      this.TotalMaintenanceScrap =
        this.dashboardData.TotalMaintenanceScrap !== undefined && this.dashboardData.TotalMaintenanceScrap !== null
          ? this.dashboardData.TotalMaintenanceScrap
          : this.dashboardData.MaintenanceScrap !== undefined && this.dashboardData.MaintenanceScrap !== null
            ? this.dashboardData.MaintenanceScrap
            : 0;
    }
  }

  makeDatatoDay() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.HeaderData.StartDate = stDT;
    this.HeaderData.EndDate = edDT;
  }

  makeDataYesterDay() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 1);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.HeaderData.StartDate = stDT;
    this.HeaderData.EndDate = edDT;
  }

  makeDataLastWeek() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 6);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.HeaderData.StartDate = stDT;
    this.HeaderData.EndDate = edDT;
  }

  makeDataLastMonth() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate() - 30);
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.HeaderData.StartDate = stDT;
    this.HeaderData.EndDate = edDT;
  }

  drawMachineChart() {
    let MachineLabel: any[] = new Array();
    let MachineData: any[] = new Array();
    if (this.UnitsByLine && this.UnitsByLine.length) {
      this.UnitsByLine.forEach((element: any) => {
        MachineLabel.push(element.puDesc);
        MachineData.push({
          name: element.puDesc,
          y: parseFloat(element.WOCount),
          color: '#0f0fd1',
          drilldown: element.puId,
        });
      });
    }

    this.highCharts = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'category',
      },
      plotOptions: {
        series: {
          events: {
            click: this.getTableData.bind(this),
          },
        },
      },
      tooltip: {
        pointFormat: 'WO Count: {point.y}',
      },
      series: [
        {
          name: this.t('Machines', 'Machines'),
          data: MachineData,
        },
      ],
      drilldown: {
        series: this.drilldownData,
      },
    };
    let chart = new Chart(this.highCharts);
    this.chartMachine = chart;
  }

  getMinerChart() {
    if (this.Minor == 0) return;
    this.isMinorChart = true;
    this.isModerateChart = false;
    this.isMajorChart = false;
    let minorLabel: any[] = new Array();
    let dialogRef = this.dialog.open(this.breakDownDialog, {
      disableClose: true,
      height: 'unset',
      width: '90%',
    });
    let minorData: any[] = new Array();

    this.minorArr.forEach((element: any) => {
      minorLabel.push('WO ID : ' + element.woID);
      minorData.push({
        name: element.woID,
        y: parseFloat(element.timeMin),
        machine: element.machine,
        color: '#0f0fd1',
      });
    });
    let minorBreakdown: any = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: minorLabel,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return (
            'Minutes : ' + this.point.y + '<br/>Machine : ' + this.point.machine
          );
        },
      },
      series: [
        {
          name: this.t('MinorBreakdown', 'Minor Breakdown'),
          type: 'column',
          data: minorData,
        },
      ],
    };
    let chart = new Chart(minorBreakdown);
    this.chartMinor = chart;
  }

  getModerateChart() {
    if (this.Moderate == 0) return;
    this.isMinorChart = false;
    this.isModerateChart = true;
    this.isMajorChart = false;
    let moderateLabel: any[] = new Array();
    let dialogRef = this.dialog.open(this.breakDownDialog, {
      disableClose: true,
      height: 'unset',
      width: '90%',
    });
    let moderateData: any[] = new Array();
    this.moderateArr.forEach((element: any) => {
      moderateLabel.push('WO ID : ' + element.woID);
      moderateData.push({
        name: element.woID,
        y: parseFloat(element.timeMin),
        machine: element.machine,
        color: '#0f0fd1',
      });
    });
    let moderateBreakdown: any = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: moderateLabel,
      },
      tooltip: {
        formatter(this: any) {
          return (
            'Minutes : ' + this.point.y + '<br/>Machine : ' + this.point.machine
          );
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.t('ModerateBreakdown', 'Moderate Breakdown'),
          type: 'column',
          data: moderateData,
        },
      ],
    };
    let chart = new Chart(moderateBreakdown);
    this.chartModerate = chart;
  }

  // getMajorChart() {
  //   if (this.Major == 0) return;
  //   this.isMinorChart = false;
  //   this.isModerateChart = false;
  //   this.isMajorChart = true;
  //   let majorLabel: any[] = new Array();
  //   let dialogRef = this.dialog.open(this.breakDownDialog, {
  //     disableClose: true,
  //     height: 'unset',
  //     width: '90%',
  //   });
  //   let majorData: any[] = new Array();
  //   this.majorArr.forEach((element: any) => {
  //     majorLabel.push('WO ID : ' + element.woID);
  //     majorData.push({
  //       name: element.woID,
  //       y: parseFloat(element.timeMin),
  //       machine: element.machine,
  //       color: '#0f0fd1',
  //       woType: element.woType
  //     });
  //   });
  //   let majorBreakdown: any = {
  //     chart: {
  //       type: 'column',
  //     },
  //     colors: ['#0f0fd1'],
  //     title: {
  //       text: '',
  //     },
  //     xAxis: {
  //       categories: majorLabel,
  //     },
  //     tooltip: {
  //       formatter(this: any) {
  //         return (
  //           'Minutes : ' + this.point.y + '<br/>Machine : ' + this.point.machine + '<br/> WorkOrder Type : ' + this.point.woType
  //         );
  //       },
  //     },
  //     credits: {
  //       enabled: false,
  //     },
  //     series: [
  //       {
  //         name: 'Major Breakdown<br/>Total(' + majorData.length + ')',
  //         type: 'column',
  //         data: majorData,
  //       },
  //     ],
  //   };
  //   let chart = new Chart(majorBreakdown);
  //   this.chartMajor = chart;
  // }

  getMajorChart() {
    if (this.Major == 0) return;
    this.isMinorChart = false;
    this.isModerateChart = false;
    this.isMajorChart = true;

    let dialogRef = this.dialog.open(this.breakDownDialog, {
      disableClose: true,
      height: 'unset',
      width: '90%',
    });

    let groupedData: { [key: string]: any[] } = {};

    this.majorArr.forEach((element: any) => {
      const entry = {
        name: element.woID,
        y: parseFloat(element.timeMin),
        machine: element.machine,
        color: '#0f0fd1',
        woType: element.woType,
      };

      if (!groupedData[element.woType]) {
        groupedData[element.woType] = [];
      }
      groupedData[element.woType].push(entry);
    });

    let seriesData = Object.keys(groupedData).map((woType) => {
      return {
        name: woType,
        y: groupedData[woType].length,
        drilldown: woType,
      };
    });

    let drilldownSeries = Object.keys(groupedData).map((woType) => {
      return {
        id: woType,
        name: this.t('WorkOrderId', 'Work Order Id'),
        data: groupedData[woType].map((entry) => [entry.name, 1]),
      };
    });

    let majorBreakdown: any = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        type: 'category',
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          if (this.point.drilldown) {
            return 'Count: <b>' + this.point.y + '</b>';
          }
          return 'Work Order Id: <b>' + this.point.name + '</b>';
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.t('WorkOrderTypes', 'Work Order Types'),
          data: seriesData,
        },
      ],
      drilldown: {
        series: drilldownSeries,
      },
    };

    let chart = new Chart(majorBreakdown);
    this.chartMajor = chart;
  }

  getTableData(event: any, line: any) {
    if (event.point.options.drilldown) {
      let data = {
        StartDate: this.HeaderData.StartDate,
        EndDate: this.HeaderData.EndDate,
        chartUnit: event.point.options.drilldown,
        ChartLine: event.point.options.drilldown != '-1' ? '' : line,
        GroupId: this.groupSession?.groupCode,
        PlantId: this.plantSession?.plantCode,
      };
      this.spinner.show();
      this.pmDashboardService.getTableData(data).subscribe(
        (res: any) => {
          this.allRowData =
            res.TableData && res.TableData.length ? res.TableData : [];
          if (
            Array.isArray(this.HeaderData.WOType) &&
            this.HeaderData.WOType.length > 0
          ) {
            this.rowData = this.allRowData.filter((x) =>
              this.HeaderData.WOType.includes(x.WOType.ID)
            );
          } else {
            this.rowData = this.allRowData.slice();
          }
          this.spinner.hide();
          this.autoSizeAllColumns();
          if (this.rowData && this.rowData.length) {
            let i = 0;
            for (const row of this.rowData) {
              if (row.managerExc) {
                let userObj = this.userList.find((user: any) => {
                  return user.employeeCode == row.managerExc.assignUser;
                });
                if (userObj) row.managerExc.assignUser = userObj;
              }
              if (row.techExc) {
                // if (row.techExc.CompleteTime && row.techExc.StartTime) {
                //   const completeTime = new Date(row.techExc.CompleteTime);
                //   const startTime = new Date(row.techExc.StartTime);
                //   const diffInMilliseconds =
                //     completeTime.getTime() - startTime.getTime();

                //   // const hours = Math.round(
                //   //   diffInMilliseconds / (1000 * 60 * 60)
                //   // );
                //   // const minutes = Math.round(
                //   //   (diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
                //   // );
                //   const totalMinutes = Math.round((diffInMilliseconds / (1000 * 60)));

                //   //  const min = Math.abs(hours * 60 + minutes);

                //   // row.techExc.RepairTime = min + ' min';
                //   row.techExc.RepairTime = totalMinutes + ' min';
                // } else row.techExc.RepairTime = '';
                if (row.techExc.AfterPicture) {
                  let techImages = row.techExc.AfterPicture.split(',');
                  row.techExc.AfterPicture = techImages[techImages.length - 1];
                }

                let woRaiseTime: any = row.TimeStamp;
                let startJobTime: any = row.techExc.StartTime;
                woRaiseTime = new Date(woRaiseTime);
                startJobTime = new Date(startJobTime);
                const diffResponseTime = Math.abs(startJobTime - woRaiseTime);
                const diffResponseMin = Math.round(diffResponseTime / 60000);
                row.ResponseTime = diffResponseMin;
              }

              if (row.techExc && row.techExc.SPRequestTime) {
                let jobStartTime: any = row.techExc.StartTime;
                let spRequestTime: any = row.techExc.SPRequestTime;
                jobStartTime = new Date(jobStartTime);
                spRequestTime = new Date(spRequestTime);
                const diffTroubleShootTime = Math.abs(
                  spRequestTime - jobStartTime
                );
                const diffTroubleShootMin = Math.round(
                  diffTroubleShootTime / 60000
                );
                row.TroubleShootTime = diffTroubleShootMin;
              }

              if (
                row.techExc &&
                row.techExc.SPRequestTime &&
                row.techExc.SPReceivedTime
              ) {
                let RequestSPTime: any = row.techExc.SPRequestTime;
                let spReceivedTime: any = row.techExc.SPReceivedTime;
                RequestSPTime = new Date(RequestSPTime);
                spReceivedTime = new Date(spReceivedTime);
                const diffWaitingSPTime = Math.abs(
                  spReceivedTime - RequestSPTime
                );
                const diffWaitingSPMin = Math.round(diffWaitingSPTime / 60000);
                row.WaitingSPTime = diffWaitingSPMin;
              }

              if (row.ClosedAt) {
                let JobStartTime: any = row.CreatedAt;
                let JobSolvedTime: any = row.ClosedAt;
                JobStartTime = new Date(JobStartTime);
                JobSolvedTime = new Date(JobSolvedTime);
                const diffMDTTime = Math.abs(JobSolvedTime - JobStartTime);
                const diffMDTMin = Math.round(diffMDTTime / 60000);
                row.MDTTime = diffMDTMin;
              }

              if (row.WOStatus == '2' || row.WOStatus == '3') {
                let startDate: any = row.CreatedAt;
                let completeDate: any =
                  row.techExc &&
                    row.techExc.CompleteTime &&
                    row.techExc.CompleteTime
                    ? row.techExc.CompleteTime
                    : '';
                startDate = new Date(startDate);
                completeDate = new Date(completeDate);
                const diffTime = Math.abs(completeDate - startDate);
                const diffMin = Math.round(diffTime / 60000);
                row.MTTRTime = diffMin;
              }

              if (this.rowData.length - 1 > i) {
                let fromDate: any = this.rowData[i].CreatedAt;
                let toDate: any = this.rowData[i + 1].CreatedAt;
                fromDate = new Date(fromDate);
                toDate = new Date(toDate);
                const diffTime = Math.abs(toDate - fromDate);
                const diffMin = Math.round(diffTime / 60000);
                row.MTBFTime = diffMin;
              }

              row.WOStatus =
                row.WOStatus == '1'
                  ? 'Open'
                  : row.WOStatus == '2'
                    ? 'Close'
                    : row.WOStatus == '3'
                      ? 'Complete'
                      : row.WOStatus == '4'
                        ? 'Delay'
                        : 'In Progress';
              if (row.UploadPicture) {
                let operatorImages = row.UploadPicture.split(',');
                row.UploadPicture = operatorImages[operatorImages.length - 1];
              }
              i++;
            }
          }

          // const groupedData = this.rowData.reduce((acc, curr) => {
          //   const { WOId } = curr;
          //   if (!acc[WOId]) {
          //     acc[WOId] = { ...curr };
          //     acc[WOId].managerExc = { ...curr.managerExc, assignUser: [] };
          //   }
          //   acc[WOId].managerExc.assignUser.push(curr.managerExc.assignUser.fullName);
          //   return acc;
          // }, {});

          const groupedData = this.rowData.reduce((acc, curr) => {
            const { WOId } = curr;
            if (!acc[WOId]) {
              acc[WOId] = { ...curr };
              acc[WOId].managerExc = curr.managerExc
                ? { ...curr.managerExc, assignUser: [] }
                : { assignUser: [] };
            }
            if (curr.managerExc && curr.managerExc.assignUser) {
              acc[WOId].managerExc.assignUser.push(
                curr.managerExc.assignUser.fullName
              );
            }
            return acc;
          }, {});

          const result = Object.values(groupedData).map((item: any) => {
            const uniqueAssignUsers = [
              ...new Set(item.managerExc?.assignUser.flat()),
            ];
            item.managerExc.assignUser = uniqueAssignUsers.join(',');
            return item;
          });

          this.rowData = result;
          this.TotalWOCompiled = result?.length;
          this.CompletedWOCompiled = result?.filter(
            (item) => item.WOStatus === 'Complete'
          ).length;
          this.OpenedWOCompiled = result?.filter(
            (item) => item.WOStatus === 'Open'
          ).length;
          this.ClosedWOCompiled = result?.filter(
            (item) => item.WOStatus === 'Close'
          ).length;
        },
        (error: any) => {
          this.toaster.error('error', error.message);
          this.spinner.hide();
        }
      );
    }
  }

  drawComponentChart() {
    let componentLabel: any[] = new Array();
    let componentData: any[] = new Array();
    if (this.ComponentByUnit && this.ComponentByUnit.length) {
      this.ComponentByUnit.forEach((element: any) => {
        componentLabel.push(element.componentName);
        componentData.push([
          element.componentName,
          parseFloat(element.WOCount),
        ]);
      });
    }
    this.highCharts = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: componentLabel,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.t('Components', 'Components'),
          type: 'column',
          data: componentData,
        },
      ],
    };
    let chart = new Chart(this.highCharts);
    this.chartComponent = chart;
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.autoSizeAllColumns();
  }

  autoSizeAllColumns() {
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  excelExport() {
    if (this.isAccess) {
      const params = {
        fileName: 'RM Dashboard ' + new Date(),
      };
      this.agGridUTCTOLocalDate.excelExport(params);
      this.gridApi.exportDataAsExcel(params);
    }
  }

  csvExport() {
    if (this.isAccess) {
      const params = {
        fileName: 'RM Dashboard ' + new Date(),
      };
      this.agGridUTCTOLocalDate.csvExport(params);
      this.gridApi.exportDataAsCsv(params);
    }
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    if (col == 'UploadPicture' || col == 'techExc.AfterPicture') {
      this.image = params && params.value ? params.value : '';
      if (this.image != '') this.openPictureBeforeModal();
    }
  }

  openPictureBeforeModal(): void {
    this.currentImagePath =
      this.image === ''
        ? 'assets/images/no-image.png'
        : Constants.BLOB_STORAGE_URL + this.image;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  imageZoomModal(imagePath: String): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  //date formatter
  dateAsYYYYMMDDHHNNSS(date: any): string {
    return (
      date.getFullYear() +
      '-' +
      this.leftpad(date.getMonth() + 1, 2) +
      '-' +
      this.leftpad(date.getDate(), 2) +
      ' ' +
      this.leftpad(date.getHours(), 2) +
      ':' +
      this.leftpad(date.getMinutes(), 2) +
      ':' +
      this.leftpad(date.getSeconds(), 2)
    );
  }

  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  toggleAllSelectionWO() {
    if (this.allSelectedWO.selected) {
      const allWO = this.filteredWOTypes.map((x) => x.ID);
      this.HeaderForm.controls.WOType.patchValue(['-1', ...allWO]);
    } else {
      this.HeaderForm.controls.WOType.patchValue([]);
    }
  }

  tosslePerOneWO() {
    if (this.allSelectedWO.selected) {
      this.allSelectedWO.deselect();
      return;
    }
    if (
      this.HeaderForm.controls.WOType.value.length ==
      this.filteredWOTypes.length
    ) {
      const allWO = this.filteredWOTypes.map((x) => x.ID);
      this.HeaderForm.controls.WOType.patchValue(['-1', ...allWO]);
    }
  }
}
